import { useUserInfo } from '@mc/user-info'
import { useBucket } from '@mc/experiments-react'

import { getUserBogoOfferEligible } from '../repositories/bogoRepository'
import { BOGO_OFFER_FLAG_NAME } from '../constants'

export const useBogo = ({ isGift = false }: { isGift?: boolean } = {}) => {
  const { user } = useUserInfo()
  const bucket = useBucket(BOGO_OFFER_FLAG_NAME)

  if (isGift) {
    return {
      isBogoOfferEligible: false,
    }
  }

  let isUserEligible = false

  if (getUserBogoOfferEligible() !== undefined) {
    // This condition is only required to support a cart flow.
    // Once the checkout migration is completed, this can be deleted
    isUserEligible = !!getUserBogoOfferEligible()
  } else {
    isUserEligible = bucket === 'variant_1'

    if (isUserEligible && user) {
      isUserEligible = user.bogoEligible
    }
  }

  return {
    isBogoOfferEligible: isUserEligible,
  }
}
